module.exports = __webpack_public_path__ + "img/l4.4.4d884e20.png";